import { Logger } from '../utils/Logger';

export interface Tracker {
	sendEvent: (event: TrackingEvent) => void;
}

export const TrackerLogger = new Logger('Tracking', {
	log: 'rgb(255, 149, 0)',
	debug: 'rgb(255, 149, 0)',
	info: 'rgb(255, 212, 38)',
	error: 'rgb(201, 52, 0)',
});

export type TrackingEvent =
	| InstalledEvent
	| LoginEvent
	| OpenTocEvent
	| CloseTocEvent
	| ShareEvent
	| LanguageOnChangeEvent
	| ButtonClickInstallEvent
	| ButtonClickLogInEvent
	| ButtonClickLogOutEvent
	| ButtonClickResponsiveEvent
	| ButtonClickReplicaEvent
	| ButtonClickSingleEvent
	| ButtonClickDoubleEvent
	| ButtonClickFavoriteArticleEvent
	| ButtonClickUnfavoriteArticleEvent
	| ButtonClickIssueEvent;

type EventType =
	| 'INSTALLED'
	| 'LOGIN'
	| 'OPEN_TOC'
	| 'CLOSE_TOC'
	| 'SHARE'
	| 'LANGUAGE_CHANGE'
	| 'BTN_CLICK_INSTALL'
	| 'BTN_CLICK_LOGIN'
	| 'BTN_CLICK_LOGOUT'
	| 'BTN_CLICK_RESPONSIVE'
	| 'BTN_CLICK_REPLICA'
	| 'BTN_CLICK_REPLICA_SINGLE'
	| 'BTN_CLICK_REPLICA_DOUBLE'
	| 'BTN_CLICK_FAVORITE_ARTICLE'
	| 'BTN_CLICK_UNFAVORITE_ARTICLE'
	| 'BTN_CLICK_ISSUE';

interface BaseEvent {
	type: EventType;
	location?: string;
}

interface InstalledEvent extends BaseEvent {
	type: 'INSTALLED';
}

interface LoginEvent extends BaseEvent {
	type: 'LOGIN';
}

interface OpenTocEvent extends BaseEvent {
	type: 'OPEN_TOC';
}

interface CloseTocEvent extends BaseEvent {
	type: 'CLOSE_TOC';
}

interface ShareEvent extends BaseEvent {
	type: 'SHARE';
	data: TrackingData;
}

export interface ButtonClickInstallEvent extends BaseEvent {
	type: 'BTN_CLICK_INSTALL';
}

export interface ButtonClickLogInEvent extends BaseEvent {
	type: 'BTN_CLICK_LOGIN';
}

interface ButtonClickResponsiveEvent extends BaseEvent {
	type: 'BTN_CLICK_RESPONSIVE';
	data: TrackingData;
}

interface ButtonClickReplicaEvent extends BaseEvent {
	type: 'BTN_CLICK_REPLICA';
	data: TrackingData;
}

interface ButtonClickSingleEvent extends BaseEvent {
	type: 'BTN_CLICK_REPLICA_SINGLE';
	data: TrackingData;
}

interface ButtonClickDoubleEvent extends BaseEvent {
	type: 'BTN_CLICK_REPLICA_DOUBLE';
	data: TrackingData;
}

interface ButtonClickFavoriteArticleEvent extends BaseEvent {
	type: 'BTN_CLICK_FAVORITE_ARTICLE';
	data: TrackingData;
}

interface ButtonClickUnfavoriteArticleEvent extends BaseEvent {
	type: 'BTN_CLICK_UNFAVORITE_ARTICLE';
	data: TrackingData;
}

interface ButtonClickLogOutEvent extends BaseEvent {
	type: 'BTN_CLICK_LOGOUT';
}

interface ButtonClickIssueEvent extends BaseEvent {
	type: 'BTN_CLICK_ISSUE';
	data: TrackingData;
}

interface LanguageOnChangeEvent extends BaseEvent {
	type: 'LANGUAGE_CHANGE';
	data: TrackingData;
}

export interface TrackingData {
	lang?: string;
	method?: 'clipboard' | 'os';
	contentType?: 'article' | 'issue';
	issue?: {
		id?: number;
		title?: string;
		slug?: string;
	};
	article?: {
		id?: number;
		ArticleID?: number;
		slug?: string;
		title?: string;
	};
}
